import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {RouterModule} from '@angular/router'
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppTranslateModule } from './app.translate.module';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { NbThemeModule, NbLayoutModule, NbFormFieldModule } from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { LayoutsModule } from './layouts/layouts.module';
import { PagesModule } from './pages/pages.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from './shared/shared.module';
//import {NgxYoutubePlayerModule } from 'ngx-youtube-player';
import { NbMenuModule, NbSidebarModule, NbContextMenuModule } from '@nebular/theme';
import { NbMenuService,
  NbUserModule,
  NbActionsModule,
  NbTabsetModule,
  NbAccordionModule,
  NbListModule,
  NbIconModule,
  NbCardModule, NbCheckboxModule,
  NbDialogModule, NbTreeGridModule,
  NbInputModule, NbSelectModule,
  NbButtonModule, NbStepperModule,
  NbTooltipModule, NbDatepickerModule,
  NbToggleModule,
  NbSpinnerModule, NbSearchModule,
  NbWindowModule,
  NbToastrModule
} from '@nebular/theme';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GalleryModule } from 'ng-gallery';
import { DatePipe } from '@angular/common';
import { NbWindowRef, NbWindowService, NbDialogService } from '@nebular/theme';
import { HammerModule } from "../../node_modules/@angular/platform-browser";

import {AppglobalService} from './services/appglobal.service';
import {BiensService} from './services/biens.service';
import {CategoriesService} from './services/categories.service';
import {SearchService} from './services/search.service';
import {UsersService} from './services/users.service';
import {AuthenticationService} from './services/auths/authentication.service';
import {AlertService} from './services/auths/alert.service';
import {PreloaderService} from './services/preloader.service';
import {ClientService} from './services/client.service';
import {FaqService} from './services/faq.service';

import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { CourousselComponent } from './couroussel/couroussel.component';
import { ContactusComponent } from './contactus/contactus.component';
import { LoginComponent } from './auth/login/login.component';
import { RegisterComponent } from './auth/register/register.component';
import { ProfileComponent } from './auth/profile/profile.component';
import { InitpasswordComponent } from './auth/initpassword/initpassword.component';
import { CountUpDirective } from './count-up.directive';

import { Ng5SliderModule } from 'ng5-slider';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    CourousselComponent,
    ContactusComponent,
    LoginComponent,
    RegisterComponent,
    ProfileComponent,
    InitpasswordComponent,
    CountUpDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AppTranslateModule,
    SharedModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    NbThemeModule.forRoot({ name: 'corporate' }),
    NbLayoutModule,
    NbSearchModule,
    NbEvaIconsModule,
    Ng5SliderModule,
    NbMenuModule.forRoot(),
    NbContextMenuModule,
    NbUserModule,
    NbActionsModule,
    NbTabsetModule,
    NbCardModule,
    GalleryModule,
    NbAccordionModule,   
    NbListModule, 
    NbIconModule,
    NbInputModule,
    NbToggleModule,
    NbFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    NbButtonModule,
    NbTooltipModule,
    NbTreeGridModule,
    NbDialogModule.forRoot(),
    HttpClientModule,
    NbSidebarModule,
    NbSidebarModule.forRoot(),
    NbInputModule,
    NbStepperModule,
    NbSelectModule, 
    NbCheckboxModule,
    NbSpinnerModule,
    NbDatepickerModule.forRoot(),
    NbWindowModule.forRoot(),
    InfiniteScrollModule,
    NbToastrModule.forRoot(),
    LayoutsModule,
    PagesModule
  ],
  providers: [
    DatePipe,
    NbMenuService,
    AppglobalService,
    BiensService, 
    CategoriesService,
    UsersService,
    SearchService,
    ClientService,
    AuthenticationService,
    AlertService,
    PreloaderService,
    NbWindowService,
    NbDialogService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
